// AUTO-GENERATED - Do not edit manually
// Run: node scripts/generate-contentful-defaults.mjs --locale=zh-CN to regenerate

export const customizations = {
  plan_customizations: [
    {
      contentful_name: '[placeholder-industries] 167161 Customization',
      plan_id: '167161',
      text_note: {
        contentful_name: '[placeholder-industries] 167161 Text Note',
        plan_year: '2024',
        short_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'We can include a custom text note here up to 140 characters!',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        long_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Additional information can go here - up to 5000 characters!',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        button_text: 'Read more',
      },
      general_note: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: 'We can include a custom text note here up to 200 characters!',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
    },
    {
      contentful_name: '[placeholder-industries] 167163 Customization',
      plan_id: '167163',
      text_note: {
        contentful_name: '[placeholder-industries] 167163 Text Note',
        plan_year: '2024',
        short_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'We can include a custom text note here up to 140 characters!',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        long_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Additional information can go here - up to 5000 characters!',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        button_text: 'Read more',
      },
      general_note: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: 'We can include a custom text note here up to 200 characters!',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
    },
    {
      contentful_name: '[placeholder-industries] 167164 Customization',
      plan_id: '167164',
      text_note: {
        contentful_name: '[placeholder-industries] 167164 Text Note',
        plan_year: '2024',
        short_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'We can include a custom text note here up to 140 characters!',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        long_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Additional information can go here - up to 5000 characters!',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        button_text: 'Read more',
      },
      general_note: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: 'We can include a custom text note here up to 200 characters!',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
    },
    {
      contentful_name: '[placeholder-industries] Custom Message Surest Copay Plan CUSTOPS-1881',
      plan_id: '820582',
      plan_page_disclaimers: [
        {
          header: 'Heads Up!',
          barColor: 'yellow',
          description:
            'With the Surest plan, when you need medical care, you can go to the website or app and see how much you’d pay for that care at doctors’ offices or hospitals near you. Depending on which doctors and hospitals you choose for the care you need, your costs may be higher or lower than what’s estimated here.',
        },
      ],
      result_page_disclaimers: [
        {
          header: 'Heads Up!',
          barColor: 'yellow',
          description:
            'With the Surest plan, when you need medical care, you can go to the website or app and see how much you’d pay for that care at doctors’ offices or hospitals near you. Depending on which doctors and hospitals you choose for the care you need, your costs may be higher or lower than what’s estimated here.',
        },
      ],
    },
    {
      contentful_name: '[placeholder-industries] Custom Message Surest On-Demand CUSTOPS-1875',
      plan_id: '820581',
      plan_page_disclaimers: [
        {
          header: 'Heads Up!',
          barColor: 'yellow',
          description:
            'With the Surest plan, when you need medical care, you can go to the website or app and see how much you’d pay for that care at doctors’ offices or hospitals near you. Depending on which doctors and hospitals you choose for the care you need, your costs may be higher or lower than what’s estimated here. Additionally, if you need to schedule certain procedures, like some surgeries, you’ll need to “activate coverage.” At least part of the cost of activating coverage would be added to your — premiums as paycheck deductions instead of out-of-pocket costs.',
        },
      ],
      result_page_disclaimers: [
        {
          header: 'Heads Up!',
          barColor: 'yellow',
          description:
            'With the Surest plan, when you need medical care, you can go to the website or app and see how much you’d pay for that care at doctors’ offices or hospitals near you. Depending on which doctors and hospitals you choose for the care you need, your costs may be higher or lower than what’s estimated here. Additionally, if you need to schedule certain procedures, like some surgeries, you’ll need to “activate coverage.” At least part of the cost of activating coverage would be added to your — premiums as paycheck deductions instead of out-of-pocket costs.',
        },
      ],
    },
    {
      contentful_name: '[placeholder-industries] Custom Message 4 Tier Network Package EVERCUST-5629 PY2024',
      plan_id: '791608',
      plan_page_disclaimers: [
        {
          header: 'Heads Up!',
          barColor: 'yellow',
          description:
            'This plan has 3 in-network coverage tiers. ALEX estimates for this plan are based on the first in-network tier, which is the smallest network, but offers the most savings. For more information on all available networks, check your plan documents.',
        },
      ],
      result_page_disclaimers: [
        {
          header: 'Heads Up!',
          barColor: 'yellow',
          description:
            'This plan has 3 in-network coverage tiers. ALEX estimates for this plan are based on the first in-network tier, which is the smallest network, but offers the most savings. For more information on all available networks, check your plan documents.',
        },
      ],
    },
    {
      contentful_name: '[placeholder-industries] 838624 Customization',
      plan_id: '838624',
      text_note: {
        contentful_name: '[placeholder-industries] 838624 Text Note',
        plan_year: '2025',
        short_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'Surest provides coverage within a range and exact amounts will vary. To learn more about those ranges and other details, check the Surest app or website.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        long_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'This text note will appear in both ALEX Benefits Counselor and ALEX Go.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        button_text: 'Read more',
      },
      general_note: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  'Surest provides coverage within a range and exact amounts will vary. To learn more about those ranges and other details, check the Surest app or website.',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: 'This information will appear in both ALEX Benefits Counselor and ALEX Go.',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
    },
    {
      contentful_name: '[placeholder-industries] Custom Message 4 Tier Network Package EVERCUST-5629 PY2025',
      plan_id: '838621',
      plan_page_disclaimers: [
        {
          header: 'Heads Up!',
          barColor: 'yellow',
          description:
            'This plan has 3 in-network coverage tiers. ALEX estimates for this plan are based on the first in-network tier, which is the smallest network, but offers the most savings. For more information on all available networks, check your plan documents.',
        },
      ],
      result_page_disclaimers: [
        {
          header: 'Heads Up!',
          barColor: 'yellow',
          description:
            'This plan has 3 in-network coverage tiers. ALEX estimates for this plan are based on the first in-network tier, which is the smallest network, but offers the most savings. For more information on all available networks, check your plan documents.',
        },
      ],
    },
    {
      contentful_name: '[placeholder-industries] 838616 Customization',
      plan_id: '838616',
      text_note: {
        contentful_name: '[placeholder-industries] 838616 Text Note',
        plan_year: '2025',
        short_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'We can include a custom text note here up to 140 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        long_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'Additional information can go here - up to 5000 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        button_text: 'Read more',
      },
      general_note: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  'We can include a custom text note here up to 200 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
    },
    {
      contentful_name: '[placeholder-industries] 838617 Customization',
      plan_id: '838617',
      text_note: {
        contentful_name: '[placeholder-industries] 838617 Text Note',
        plan_year: '2025',
        short_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'We can include a custom text note here up to 140 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        long_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'Additional information can go here - up to 5000 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        button_text: 'Read more',
      },
      general_note: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  'We can include a custom text note here up to 200 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
    },
    {
      contentful_name: '[placeholder-industries] 838618 Customization',
      plan_id: '838618',
      text_note: {
        contentful_name: '[placeholder-industries] 838618 Text Note',
        plan_year: '2025',
        short_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'We can include a custom text note here up to 140 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        long_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'Additional information can go here - up to 5000 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        button_text: 'Read more',
      },
      general_note: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value:
                  'We can include a custom text note here up to 200 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
    },
    {
      contentful_name: '[placeholder-industries] 838619 Customization',
      plan_id: '838619',
      text_note: {
        contentful_name: '[placeholder-industries] 838619 Text Note',
        plan_year: '2025',
        short_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'We can include a custom text note here up to 140 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        long_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'Additional information can go here - up to 5000 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        button_text: 'Read more',
      },
      general_note: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  'We can include a custom text note here up to 200 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
    },
    {
      contentful_name: '[placeholder-industries] 838621 Customization',
      plan_id: '838621',
      text_note: {
        contentful_name: '[placeholder-industries] 838621 Text Note',
        plan_year: '2025',
        short_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'We can include a custom text note here up to 140 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        long_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'Additional information can go here - up to 5000 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        button_text: 'Read more',
      },
      general_note: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value:
                  'We can include a custom text note here up to 200 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
    },
    {
      contentful_name: '[placeholder-industries] 838623 Customization',
      plan_id: '838623',
      text_note: {
        contentful_name: '[placeholder-industries] 838623 Text Note',
        plan_year: '2025',
        short_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'Surest is a health plan offering choice, flexibility and clarity. It allows you to activate coverage when your needs change.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        long_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'This text note will appear in both ALEX Benefits Counselor and ALEX Go.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        button_text: 'Read more',
      },
      general_note: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  'Listed above are average prices. There are 45 plannable procedures or surgeries that you have to “activate coverage” for at least three days in advance. See the full list below or contact Surest. ',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: 'This information will appear in both ALEX Benefits Counselor and ALEX Go.',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
    },
    {
      contentful_name: '[placeholder-industries] 167162 Customization',
      plan_id: '167162',
      text_note: {
        contentful_name: '[placeholder-industries] 167162 Text Note',
        plan_year: '2024',
        short_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'We can include a custom text note here up to 140 characters!',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        long_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Additional information can go here - up to 5000 characters!',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        button_text: 'Read more',
      },
      general_note: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: 'We can include a custom text note here up to 200 characters!',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
    },
    {
      contentful_name: '[placeholder-industries] 791608 Customization',
      plan_id: '791608',
      text_note: {
        contentful_name: '[placeholder-industries] 791608 Text Note',
        plan_year: '2024',
        short_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'We can include a custom text note here up to 140 characters!',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        long_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Additional information can go here - up to 5000 characters!',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        button_text: 'Read more',
      },
      general_note: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: 'We can include a custom text note here up to 200 characters!',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
    },
    {
      contentful_name: '[placeholder-industries] 820581 Customization',
      plan_id: '820581',
      text_note: {
        contentful_name: '[placeholder-industries] 820581 Text Note',
        plan_year: '2024',
        short_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'Surest is a health plan offering choice, flexibility and clarity. It allows you to activate coverage when your needs change.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        button_text: 'Read more',
      },
      general_note: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  'Listed above are average prices. There are 45 plannable procedures or surgeries that you have to “activate coverage” for at least three days in advance. See the full list below or contact Surest.',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
    },
    {
      contentful_name: '[placeholder-industries] 820582 Customization',
      plan_id: '820582',
      text_note: {
        contentful_name: '[placeholder-industries] 820582 Text Note',
        plan_year: '2024',
        short_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'Surest provides coverage within a range and exact amounts will vary. To learn more about those ranges and other details, check the Surest app or website.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        button_text: 'Read more',
      },
      general_note: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  'Surest provides coverage within a range and exact amounts will vary. To learn more about those ranges and other details, check the Surest app or website.',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
    },
    {
      contentful_name: '[placeholder-industries] 1035215 Customization',
      plan_id: '1035215',
      text_note: {
        contentful_name: '[placeholder-industries] 1035215 Text Note',
        plan_year: '2026',
        short_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'We can include a custom text note here up to 140 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        long_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'Additional information can go here - up to 5000 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        button_text: 'Read more',
      },
      general_note: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  'We can include a custom text note here up to 200 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      rx_tier: {
        rx_tier_1: {
          name: 'Tier 1',
        },
        rx_tier_2: {
          name: 'Tier 2',
        },
        rx_tier_3: {
          name: 'Tier 3',
        },
      },
    },
    {
      contentful_name: '[placeholder-industries] 1035216 Customization',
      plan_id: '1035216',
      text_note: {
        contentful_name: '[placeholder-industries] 1035216 Text Note',
        plan_year: '2026',
        short_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'We can include a custom text note here up to 140 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        long_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'Additional information can go here - up to 5000 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        button_text: 'Read more',
      },
      general_note: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  'We can include a custom text note here up to 200 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      rx_tier: {
        rx_tier_1: {
          name: 'Tier 1',
        },
        rx_tier_2: {
          name: 'Tier 2',
        },
        rx_tier_3: {
          name: 'Tier 3',
        },
      },
    },
    {
      contentful_name: '[placeholder-industries] 1035217 Customization',
      plan_id: '1035217',
      text_note: {
        contentful_name: '[placeholder-industries] 1035217 Text Note',
        plan_year: '2026',
        short_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'We can include a custom text note here up to 140 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        long_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'Additional information can go here - up to 5000 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        button_text: 'Read more',
      },
      general_note: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  'We can include a custom text note here up to 200 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      rx_tier: {
        rx_tier_1: {
          name: 'Tier 1',
        },
        rx_tier_2: {
          name: 'Tier 2',
        },
        rx_tier_3: {
          name: 'Tier 3',
        },
      },
    },
    {
      contentful_name: '[placeholder-industries] 1035218 Customization',
      plan_id: '1035218',
      text_note: {
        contentful_name: '[placeholder-industries] 1035218 Text Note',
        plan_year: '2026',
        short_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'We can include a custom text note here up to 140 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        long_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'Additional information can go here - up to 5000 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        button_text: 'Read more',
      },
      general_note: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  'We can include a custom text note here up to 200 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      rx_tier: {
        rx_tier_1: {
          name: 'Tier 1',
        },
        rx_tier_2: {
          name: 'Tier 2',
        },
        rx_tier_3: {
          name: 'Tier 3',
        },
      },
    },
    {
      contentful_name:
        '[placeholder-industries] 1035220 Custom Message 4 Tier Network Package EVERCUST-5629 PY2026',
      plan_id: '1035220',
      plan_page_disclaimers: [
        {
          header: 'Important:',
          barColor: 'yellow',
          description:
            'ALEX estimates for this plan are based on the most preferred in-network tier, but this plan has multiple in-network coverage tiers. For a comprehensive breakdown of your coverage in each network tier, check your plan documents or restart ALEX and select the Audio-Led Experience.',
        },
      ],
      result_page_disclaimers: [
        {
          header: 'Important:',
          barColor: 'yellow',
          description:
            'ALEX estimates for this plan are based on the most preferred in-network tier, but this plan has multiple in-network coverage tiers. For a comprehensive breakdown of your coverage in each network tier, check your plan documents or restart ALEX and select the Audio-Led Experience.',
        },
      ],
      text_note: {
        contentful_name: '[placeholder-industries] 1035220 Text Note',
        plan_year: '2026',
        short_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'We can include a custom text note here up to 140 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        long_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'Additional information can go here - up to 5000 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        button_text: 'Read more',
      },
      general_note: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  'We can include a custom text note here up to 200 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      rx_tier: {
        rx_tier_1: {
          name: 'Tier 1',
        },
        rx_tier_2: {
          name: 'Tier 2',
        },
        rx_tier_3: {
          name: 'Tier 3',
        },
      },
    },
    {
      contentful_name: '[placeholder-industries] 1035222 Customization',
      plan_id: '1035222',
      text_note: {
        contentful_name: '[placeholder-industries] 1035222 Text Note',
        plan_year: '2026',
        short_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'Surest is a health plan offering choice, flexibility and clarity. It allows you to activate coverage when your needs change.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        long_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'This text note will appear in both ALEX Benefits Counselor and ALEX Go.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        button_text: 'Read more',
      },
      general_note: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  'Listed above are average prices. There are 45 plannable procedures or surgeries that you have to “activate coverage” for at least three days in advance. See the full list below or contact Surest. ',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: 'This information will appear in both ALEX Benefits Counselor and ALEX Go.',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
    },
    {
      contentful_name: '[placeholder-industries] 1035223 Customization',
      plan_id: '1035223',
      text_note: {
        contentful_name: '[placeholder-industries] 1035223 Text Note',
        plan_year: '2026',
        short_text: {
          nodeType: 'document',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              content: [
                {
                  nodeType: 'text',
                  value:
                    'This plan provides coverage within a range and exact amounts will vary. To learn more about those ranges and other details, check the app or website.',
                  marks: [],
                  data: {},
                },
              ],
              data: {},
            },
          ],
        },
        long_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'This text note will appear in both ALEX Benefits Counselor and ALEX Go.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        button_text: 'Read more',
      },
      general_note: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  'Surest provides coverage within a range and exact amounts will vary. To learn more about those ranges and other details, check the Surest app or website.',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: 'This information will appear in both ALEX Benefits Counselor and ALEX Go.',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      rx_tier: {
        rx_tier_1: {
          name: 'Tier 1',
        },
        rx_tier_2: {
          name: 'Tier 2',
        },
        rx_tier_3: {
          name: 'Tier 3',
        },
        rx_tier_4: {
          name: 'Tier 4',
        },
      },
    },
    {
      contentful_name: '[placeholder-industries] 1069667 Customization',
      plan_id: '1069667',
      text_note: {
        contentful_name: '[placeholder-industries] 1069667 Text Note',
        plan_year: '2026',
        short_text: {
          nodeType: 'document',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              content: [
                {
                  nodeType: 'text',
                  value:
                    'Surest provides coverage within a range and exact amounts will vary. To learn more about those ranges and other details, check the Surest app or website.',
                  marks: [],
                  data: {},
                },
              ],
              data: {},
            },
          ],
        },
        long_text: {
          nodeType: 'document',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              content: [
                {
                  nodeType: 'text',
                  value: 'This text note will appear in both ALEX Benefits Counselor and ALEX Go.',
                  marks: [],
                  data: {},
                },
              ],
              data: {},
            },
          ],
        },
        button_text: 'Read more',
      },
      general_note: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  'This plan provides coverage within a range and exact amounts will vary. To learn more about those ranges and other details, check the app or website.',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: 'This information will appear in both ALEX Benefits Counselor and ALEX Go.',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      rx_tier: {
        rx_tier_1: {
          name: 'Tier 1',
        },
        rx_tier_2: {
          name: 'Tier 2',
        },
        rx_tier_3: {
          name: 'Tier 3',
        },
        rx_tier_4: {
          name: 'Tier 4',
        },
      },
    },
    {
      contentful_name: '[placeholder-industries] 1069670 Customization',
      plan_id: '1069670',
      text_note: {
        contentful_name: '[placeholder-industries] 1069670 Text Note',
        plan_year: '2026',
        short_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'The Coupe plans use three tiers of copays for most health care needs. The copays used for calculations are the most-common amounts. You may pay less or more, depending upon where you choose to receive care, and which doctor you see.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        long_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'This text note will appear in both ALEX Benefits Counselor and ALEX Go.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        button_text: 'Read more',
      },
      general_note: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value:
                  'The Coupe plans use three tiers of copays for most health care needs. The copays used for calculations are the most-common amounts. You may pay less or more, depending upon where you choose to receive care, and which doctor you see.',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value: 'This information will appear in both ALEX Benefits Counselor and ALEX Go.',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
    },
    {
      contentful_name: '[placeholder-industries] 1069671 Customization',
      plan_id: '1069671',
      text_note: {
        contentful_name: '[placeholder-industries] 1069671 Text Note',
        plan_year: '2026',
        short_text: {
          nodeType: 'document',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              content: [
                {
                  nodeType: 'text',
                  value:
                    'SimplePay Health provides coverage within a range and exact amounts will vary. To learn more about those ranges and other details, check SimplePay’s member portal.',
                  marks: [],
                  data: {},
                },
              ],
              data: {},
            },
          ],
        },
        long_text: {
          nodeType: 'document',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              content: [
                {
                  nodeType: 'text',
                  value: 'This information will appear in both ALEX Benefits Counselor and ALEX Go.',
                  marks: [],
                  data: {},
                },
              ],
              data: {},
            },
          ],
        },
        button_text: 'Read more',
      },
      general_note: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  'SimplePay Health provides coverage within a range and exact amounts will vary. To learn more about those ranges and other details, check SimplePay’s member portal. ',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: 'This information will appear in both ALEX Benefits Counselor and ALEX Go.',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
    },
    {
      contentful_name: '[placeholder-industries] 1074209 Customization',
      plan_id: '1074209',
      text_note: {
        contentful_name: '[placeholder-industries] 1074209 Text Note',
        plan_year: '2026',
        short_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'The Coupe plans use three tiers of copays for most health care needs. The copays used for calculations are the most-common amounts. You may pay less or more, depending upon where you choose to receive care, and which doctor you see.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        long_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'This text note will appear in both ALEX Benefits Counselor and ALEX Go.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        button_text: 'Read more',
      },
      general_note: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  'This plan uses three tiers of copays for most health care needs. The copays used for calculations are the most-common amounts. You may pay less or more depending upon where you choose to receive care.',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      rx_tier: {
        rx_tier_1: {
          name: 'Tier 1',
        },
        rx_tier_2: {
          name: 'Tier 2',
        },
        rx_tier_3: {
          name: 'Tier 3',
        },
        rx_tier_4: {
          name: 'Tier 4',
        },
      },
    },
    {
      contentful_name: '[placeholder-industries] 1074211 Customization',
      plan_id: '1074211',
      text_note: {
        contentful_name: '[placeholder-industries] 1074211 Text Note',
        plan_year: '2026',
        short_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'With SimplePay, providers are categorized into three copay rankings - Best, Better, and OK - based on quality, relationship, experience, and efficiency. Find more information and pricing details on the SimplePay member portal. SimplePay Health provides coverage within a range and exact amounts will vary.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        long_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'This text note will appear in both ALEX Benefits Counselor and ALEX Go.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        button_text: 'Read more',
      },
      general_note: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  'With SimplePay, providers are categorized into three copay rankings - Best, Better, and OK - based on quality, relationship, experience, and efficiency. Find more information and pricing details on the SimplePay member portal. SimplePay Health provides coverage within a range and exact amounts will vary. ',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: 'This information will appear in both ALEX Benefits Counselor and ALEX Go.',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      rx_tier: {
        rx_tier_1: {
          name: 'Tier 1',
        },
        rx_tier_2: {
          name: 'Tier 2',
        },
        rx_tier_3: {
          name: 'Tier 3',
        },
        rx_tier_4: {
          name: 'Tier 4',
        },
      },
    },
    {
      contentful_name: '[placeholder-industries] 1310326 Customization',
      plan_id: '1310326',
      text_note: {
        contentful_name: '[placeholder-industries] 1310326 Text Note',
        plan_year: '2027',
        short_text: {
          nodeType: 'document',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              content: [
                {
                  nodeType: 'text',
                  value:
                    'We can include a custom text note here up to 140 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                  marks: [],
                  data: {},
                },
              ],
              data: {},
            },
          ],
        },
        long_text: {
          nodeType: 'document',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              content: [
                {
                  nodeType: 'text',
                  value:
                    'Additional information can go here - up to 5000 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                  marks: [],
                  data: {},
                },
              ],
              data: {},
            },
          ],
        },
        button_text: 'Read more',
      },
      general_note: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value:
                  'We can include a custom text note here up to 200 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      rx_tier: {
        rx_tier_1: {
          name: 'Tier 1',
        },
        rx_tier_2: {
          name: 'Tier 2',
        },
        rx_tier_3: {
          name: 'Tier 3',
        },
      },
    },
    {
      contentful_name: '[placeholder-industries] 1310327 Customization',
      plan_id: '1310327',
      text_note: {
        contentful_name: '[placeholder-industries] 1310327 Text Note',
        plan_year: '2027',
        short_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'We can include a custom text note here up to 140 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        long_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'Additional information can go here - up to 5000 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        button_text: 'Read more',
      },
      general_note: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  'We can include a custom text note here up to 200 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      rx_tier: {
        rx_tier_1: {
          name: 'Tier 1',
        },
        rx_tier_2: {
          name: 'Tier 2',
        },
        rx_tier_3: {
          name: 'Tier 3',
        },
      },
    },
    {
      contentful_name: '[placeholder-industries] 1310328 Customization',
      plan_id: '1310328',
      text_note: {
        contentful_name: '[placeholder-industries] 1310328 Text Note',
        plan_year: '2027',
        short_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'We can include a custom text note here up to 140 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        long_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'Additional information can go here - up to 5000 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        button_text: 'Read more',
      },
      general_note: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value:
                  'We can include a custom text note here up to 200 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      rx_tier: {
        rx_tier_1: {
          name: 'Tier 1',
        },
        rx_tier_2: {
          name: 'Tier 2',
        },
        rx_tier_3: {
          name: 'Tier 3',
        },
      },
    },
    {
      contentful_name: '[placeholder-industries] 1310329 Customization',
      plan_id: '1310329',
      text_note: {
        contentful_name: '[placeholder-industries] 1310329 Text Note',
        plan_year: '2027',
        short_text: {
          nodeType: 'document',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              content: [
                {
                  nodeType: 'text',
                  value:
                    'We can include a custom text note here up to 140 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                  marks: [],
                  data: {},
                },
              ],
              data: {},
            },
          ],
        },
        long_text: {
          nodeType: 'document',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              content: [
                {
                  nodeType: 'text',
                  value:
                    'Additional information can go here - up to 5000 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                  marks: [],
                  data: {},
                },
              ],
              data: {},
            },
          ],
        },
        button_text: 'Read more',
      },
      general_note: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value:
                  'We can include a custom text note here up to 200 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      rx_tier: {
        rx_tier_1: {
          name: 'Tier 1',
        },
        rx_tier_2: {
          name: 'Tier 2',
        },
        rx_tier_3: {
          name: 'Tier 3',
        },
      },
    },
    {
      contentful_name:
        '[placeholder-industries] 1310331 Customization Custom Message 4 Tier Network Package EVERCUST-5629 PY2027',
      plan_id: '1310331',
      plan_page_disclaimers: [
        {
          header: 'Important:',
          barColor: 'yellow',
          description:
            'ALEX estimates for this plan are based on the most preferred in-network tier, but this plan has multiple in-network coverage tiers. For a comprehensive breakdown of your coverage in each network tier, check your plan documents or restart ALEX and select the Audio-Led Experience.',
        },
      ],
      result_page_disclaimers: [
        {
          header: 'Important:',
          barColor: 'yellow',
          description:
            'ALEX estimates for this plan are based on the most preferred in-network tier, but this plan has multiple in-network coverage tiers. For a comprehensive breakdown of your coverage in each network tier, check your plan documents or restart ALEX and select the Audio-Led Experience.',
        },
      ],
      text_note: {
        contentful_name: '[placeholder-industries] 1310331 Text Note',
        plan_year: '2027',
        short_text: {
          nodeType: 'document',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              content: [
                {
                  nodeType: 'text',
                  value:
                    'We can include a custom text note here up to 140 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                  marks: [],
                  data: {},
                },
              ],
              data: {},
            },
          ],
        },
        long_text: {
          nodeType: 'document',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              content: [
                {
                  nodeType: 'text',
                  value:
                    'Additional information can go here - up to 5000 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                  marks: [],
                  data: {},
                },
              ],
              data: {},
            },
          ],
        },
        button_text: 'Read more',
      },
      general_note: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  'We can include a custom text note here up to 200 characters! Information here will appear in both ALEX Benefits Counselor and ALEX Go.',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      rx_tier: {
        rx_tier_1: {
          name: 'Tier 1',
        },
        rx_tier_2: {
          name: 'Tier 2',
        },
        rx_tier_3: {
          name: 'Tier 3',
        },
      },
    },
    {
      contentful_name: '[placeholder-industries] 1310333 Customization',
      plan_id: '1310333',
      plan_page_disclaimers: [
        {
          header: 'Important:',
          barColor: 'yellow',
          description:
            'ALEX estimates for this plan are based on the most preferred in-network tier, but this plan has multiple in-network coverage tiers. For a comprehensive breakdown of your coverage in each network tier, check your plan documents or restart ALEX and select the Audio-Led Experience.',
        },
      ],
      result_page_disclaimers: [
        {
          header: 'Important:',
          barColor: 'yellow',
          description:
            'ALEX estimates for this plan are based on the most preferred in-network tier, but this plan has multiple in-network coverage tiers. For a comprehensive breakdown of your coverage in each network tier, check your plan documents or restart ALEX and select the Audio-Led Experience.',
        },
      ],
      text_note: {
        contentful_name: '[placeholder-industries] 1310333 Text Note',
        plan_year: '2027',
        short_text: {
          nodeType: 'document',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              content: [
                {
                  nodeType: 'text',
                  value:
                    'This plan provides coverage within a range and exact amounts will vary. To learn more about those ranges and other details, check the app or website.',
                  marks: [],
                  data: {},
                },
              ],
              data: {},
            },
          ],
        },
        long_text: {
          nodeType: 'document',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              content: [
                {
                  nodeType: 'text',
                  value: 'This text note will appear in both ALEX Benefits Counselor and ALEX Go.',
                  marks: [],
                  data: {},
                },
              ],
              data: {},
            },
          ],
        },
        button_text: 'Read more',
      },
      general_note: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  'Surest provides coverage within a range and exact amounts will vary. To learn more about those ranges and other details, check the Surest app or website.',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: 'This information will appear in both ALEX Benefits Counselor and ALEX Go.',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      rx_tier: {
        rx_tier_1: {
          name: 'Tier 1',
        },
        rx_tier_2: {
          name: 'Tier 2',
        },
        rx_tier_3: {
          name: 'Tier 3',
        },
        rx_tier_4: {
          name: 'Tier 4',
        },
      },
    },
    {
      contentful_name: '[placeholder-industries] 1310334 Customization',
      plan_id: '1310334',
      text_note: {
        contentful_name: '[placeholder-industries] 1310334 Text Note',
        plan_year: '2027',
        short_text: {
          nodeType: 'document',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              content: [
                {
                  nodeType: 'text',
                  value:
                    'Surest provides coverage within a range and exact amounts will vary. To learn more about those ranges and other details, check the Surest app or website.',
                  marks: [],
                  data: {},
                },
              ],
              data: {},
            },
          ],
        },
        long_text: {
          nodeType: 'document',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              content: [
                {
                  nodeType: 'text',
                  value: 'This text note will appear in both ALEX Benefits Counselor and ALEX Go.',
                  marks: [],
                  data: {},
                },
              ],
              data: {},
            },
          ],
        },
        button_text: 'Read more',
      },
      general_note: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value:
                  'This plan provides coverage within a range and exact amounts will vary. To learn more about those ranges and other details, check the app or website.',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value: 'This information will appear in both ALEX Benefits Counselor and ALEX Go.',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      rx_tier: {
        rx_tier_1: {
          name: 'Tier 1',
        },
        rx_tier_2: {
          name: 'Tier 2',
        },
        rx_tier_3: {
          name: 'Tier 3',
        },
        rx_tier_4: {
          name: 'Tier 4',
        },
      },
    },
    {
      contentful_name: '[placeholder-industries] 1310335 Customization',
      plan_id: '1310335',
      text_note: {
        contentful_name: '[placeholder-industries] 1310335 Text Note',
        plan_year: '2027',
        short_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'The Coupe plans use three tiers of copays for most health care needs. The copays used for calculations are the most-common amounts. You may pay less or more, depending upon where you choose to receive care, and which doctor you see.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        long_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'This text note will appear in both ALEX Benefits Counselor and ALEX Go.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        button_text: 'Read more',
      },
      general_note: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value:
                  'This plan uses three tiers of copays for most health care needs. The copays used for calculations are the most-common amounts. You may pay less or more depending upon where you choose to receive care.',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      rx_tier: {
        rx_tier_1: {
          name: 'Tier 1',
        },
        rx_tier_2: {
          name: 'Tier 2',
        },
        rx_tier_3: {
          name: 'Tier 3',
        },
        rx_tier_4: {
          name: 'Tier 4',
        },
      },
    },
    {
      contentful_name: '[placeholder-industries] 1310336 Customization',
      plan_id: '1310336',
      text_note: {
        contentful_name: '[placeholder-industries] 1310336 Text Note',
        plan_year: '2027',
        short_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'With SimplePay, providers are categorized into three copay rankings - Best, Better, and OK - based on quality, relationship, experience, and efficiency. Find more information and pricing details on the SimplePay member portal. SimplePay Health provides coverage within a range and exact amounts will vary.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        long_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'This text note will appear in both ALEX Benefits Counselor and ALEX Go.',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        button_text: 'Read more',
      },
      general_note: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  'With SimplePay, providers are categorized into three copay rankings - Best, Better, and OK - based on quality, relationship, experience, and efficiency. Find more information and pricing details on the SimplePay member portal. SimplePay Health provides coverage within a range and exact amounts will vary. ',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: 'This information will appear in both ALEX Benefits Counselor and ALEX Go.',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      rx_tier: {
        rx_tier_1: {
          name: 'Tier 1',
        },
        rx_tier_2: {
          name: 'Tier 2',
        },
        rx_tier_3: {
          name: 'Tier 3',
        },
        rx_tier_4: {
          name: 'Tier 4',
        },
      },
    },
  ],
};
